export const isNewerThan = (date: Date, days: number) => {
  if (Math.ceil(Math.abs(new Date() - date) / (1000 * 60 * 60 * 24)) <= days) {
    return true
  }
  return false
}
